import {
	ShareBaseItem,
	ShareBaseFolder,
	ShareBaseDocument,
	FavoriteItem
} from 'phoenix/domain';
import {
	TrackingService
} from './trackingService'

export class FavoritesService {
	public static $inject = [
		'$http',
		'settingsService',
	]

	constructor(
		private readonly $http:ng.IHttpService,
		private readonly settingsService:any,
	) {
	}

	public getFavorites() {
		return this.$http.get(this.settingsService.serverAPIPath + '/favorites')
			.then((response:any) => response.data as FavoriteItem[]);
	}

	public setFolderAsFavorite(folderId:number) {
		return this.$http.put(this.settingsService.serverAPIPath + '/favorites/folders/' + folderId, {});
	}

	public removeFolderFromFavorites(folderId:number) {
		return this.$http.delete(this.settingsService.serverAPIPath + '/favorites/folders/' + folderId);
	}

	public setDocumentAsFavorite(documentId:number) {
		return this.$http.put(this.settingsService.serverAPIPath + '/favorites/documents/' + documentId, {});
	}

	public removeDocumentFromFavorites(documentId:number){
		return this.$http.delete(this.settingsService.serverAPIPath + '/favorites/documents/' + documentId).then(angular.noop);
	}
}

export class TrackableFavoritesService extends FavoritesService {
	public static $inject = [
		'$http',
		'settingsService',
		'$location',
		'sbTrackingService'
	]

	constructor(
		$http:ng.IHttpService,
		settingsService:any,
		private readonly $location:ng.ILocationService,
		private readonly sbTrackingService:TrackingService
	) {
		super($http, settingsService);
	}

	private sanitizedPath() {
		return this.$location.path().replace(/\/[0-9]+/g, '');
	}

	public getFavorites() {
		return super.getFavorites();
	}

	public setFolderAsFavorite(folderId:number) {
		this.sbTrackingService.trackClick('favorite a folder', this.sanitizedPath());
		return super.setFolderAsFavorite(folderId);
	}

	public removeFolderFromFavorites(folderId:number) {
		this.sbTrackingService.trackClick('unfavorite a folder', this.sanitizedPath());
		return super.removeFolderFromFavorites(folderId);
	}

	public setDocumentAsFavorite(documentId:number) {
		this.sbTrackingService.trackClick('favorite a document', this.sanitizedPath());
		return super.setDocumentAsFavorite(documentId);
	}

	public removeDocumentFromFavorites(documentId:number) {
		this.sbTrackingService.trackClick('unfavorite a document', this.sanitizedPath());
		return super.removeDocumentFromFavorites(documentId);
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/services/favoritesService.ts